import { QueryStatus } from '@reduxjs/toolkit/dist/query';
import Pill from 'Components/Pills';
import { IAttachment } from '.';

interface DocumentProps {
  attachment: IAttachment;
  onDelete: (id: string) => void;
  state?: QueryStatus;
}
export default function DocumentPill({
  attachment,
  onDelete = () => {},
  state,
}: DocumentProps) {
  const { id, staged, uploaded } = attachment;

  if (attachment.errors?.maxFileSizeExceeded) {
    return (
      <Pill.Error
        children={staged.name}
        tooltip={attachment.errors.maxFileSizeExceeded}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onDelete(id);
        }}
      />
    );
  }

  if (attachment.errors?.invalidFileType) {
    return (
      <Pill.Error
        children={staged.name}
        tooltip={attachment.errors.invalidFileType}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onDelete(id);
        }}
      />
    );
  }

  if (state === QueryStatus.uninitialized) {
    return (
      <Pill.Delete
        children={staged.name}
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onDelete(id);
        }}
      />
    );
  }

  if (state === QueryStatus.pending) {
    return <Pill.Loading children={staged.name} />;
  }

  if (state === QueryStatus.fulfilled) {
    return <Pill.Success children={staged.name} />;
  }

  if (state === QueryStatus.rejected) {
    return (
      <Pill.Error
        children={staged.name}
        tooltip="Upload Error, remove item to send message"
        onClick={(e) => {
          e.stopPropagation();
          e.preventDefault();
          onDelete(id);
        }}
      />
    );
  }
  return <Pill.Default children={staged.name} />;
}
